module.exports = __webpack_public_path__ + "static/media/map.d7c65b3f.obj";